const eInsightBaseUrl = process.env.VUE_APP_EINSIGHT_URL
const eInsightUrl = {
  view: (projectId) => eInsightBaseUrl + 'Project/ManageCampaigns?projectId=' + `${projectId}`
}

export default eInsightUrl
